import { render, staticRenderFns } from "./channelModal.vue?vue&type=template&id=683e81ff&scoped=true&"
import script from "./channelModal.vue?vue&type=script&lang=js&"
export * from "./channelModal.vue?vue&type=script&lang=js&"
import style0 from "./channelModal.vue?vue&type=style&index=0&id=683e81ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683e81ff",
  null
  
)

export default component.exports